import {
  GetPreviewDataDocument,
  type GetPreviewDataQuery,
} from '@seek/cmsu-cms-connect';
import type { LoaderFunction } from 'react-router';

import {
  getPreviewDocumentData,
  getPreviewProps,
} from '../helpers/loadersHelper';
import { internalError, notFound } from '../responses';
import type { RouteProps } from '../routes';
import { json } from '../server/utils/json';

/**
 * This loader is used to fetch the preview data for article and page
 * @param config
 * @param client
 */
export const previewDocumentLoader =
  ({ config, client }: RouteProps): LoaderFunction =>
  async ({ params }) => {
    // if there is no Article or Page id provided
    if (!params.id) {
      throw notFound(params.slug);
    }

    // if the Draft content needs to be displayed, need to use Token
    const { stage, queryOptions } = getPreviewProps(config.isDraft);

    // use single query to obtain article or page
    const variables = {
      whereArticle: {
        id: params.id,
      },
      wherePage: {
        id: params.id,
      },
      stage,
    };

    // Fetch the article if it exists.
    const { data, error } = await client.query<GetPreviewDataQuery>({
      query: GetPreviewDataDocument,
      variables,
      ...queryOptions,
    });

    if (error) {
      throw internalError(error);
    }

    // If the page or article are not available, redirect user to NotFound Page
    if (
      !data.article?.localizations?.length &&
      !data.page?.localizations?.length
    ) {
      throw notFound(params.slug);
    }

    const previewData = getPreviewDocumentData(config, data);

    return json(previewData);
  };
